export interface Actor {
  id: string;
  name: string;
  avatar: string;
  birthYear: number;
  region: string;
  height: string;
  roleTag: string;
  summary: string;
  bio: string[];
  workIds: string[];
}

export const actors: Actor[] = [
  {
    id: 'lin-xiaomei',
    name: '林晓莓',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actress%20with%20soft%20natural%20lighting%20against%20a%20peach%20toned%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20gentle%20expression%2C%20high%20detail&width=500&height=500&seq=actor-lin-xiaomei-a1&orientation=squarish',
    birthYear: 1988,
    region: '中国香港',
    height: '168cm',
    roleTag: '本片女主角',
    summary: '以细腻克制的表演风格著称，擅长塑造内心戏丰富的都市女性形象。',
    bio: [
      '林晓莓是《蜜桃成熟时33D》的女主角，在片中饰演在旧影碟店工作的林晓莓，将角色从犹豫到释然的转变刻画得层次分明。',
      '她以自然不做作的表演受到观众喜爱，擅长通过细微的眼神与停顿传递角色的情绪变化。',
    ],
    workIds: ['peach-33d', 'rose-apartment'],
  },
  {
    id: 'su-mo',
    name: '苏陌',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actor%20with%20soft%20natural%20lighting%20against%20a%20warm%20amber%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20calm%20expression%2C%20high%20detail&width=500&height=500&seq=actor-su-mo-b2&orientation=squarish',
    birthYear: 1986,
    region: '中国香港',
    height: '182cm',
    roleTag: '本片男主角',
    summary: '气质沉静的实力派演员，多次出演文艺与都市题材作品。',
    bio: [
      '苏陌在《蜜桃成熟时33D》中饰演男主角苏陌，是女主角多年后重新遇见的旧识。',
      '他偏好选择有层次的角色，善于用内敛的表演呈现人物复杂的内心世界。',
    ],
    workIds: ['peach-33d', 'peach-2', 'rose-apartment'],
  },
  {
    id: 'gu-qinghe',
    name: '顾青禾',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actress%20with%20soft%20natural%20lighting%20against%20a%20soft%20cream%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20bright%20youthful%20expression%2C%20high%20detail&width=500&height=500&seq=actor-gu-qinghe-c3&orientation=squarish',
    birthYear: 1993,
    region: '中国台湾',
    height: '165cm',
    roleTag: '主演',
    summary: '青春题材中的常客，表演清新自然，富有感染力。',
    bio: [
      '顾青禾在《蜜桃成熟时33D》中饰演女主角的挚友，是推动剧情的重要角色。',
      '她的表演清新自然，在多部青春与文艺作品中都有亮眼表现。',
    ],
    workIds: ['peach-33d', 'summer-heartbeat', 'old-letter', 'rainy-monsoon'],
  },
  {
    id: 'shen-yibai',
    name: '沈亦白',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20middle%20aged%20Chinese%20actor%20with%20soft%20natural%20lighting%20against%20a%20warm%20taupe%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20thoughtful%20expression%2C%20high%20detail&width=500&height=500&seq=actor-shen-yibai-d4&orientation=squarish',
    birthYear: 1979,
    region: '中国大陆',
    height: '178cm',
    roleTag: '主演',
    summary: '资深演员，擅长演绎沉稳内敛的长辈与导师类角色。',
    bio: [
      '沈亦白在《蜜桃成熟时33D》中饰演影碟店的老板，是女主角人生道路上的引路人。',
      '他以扎实的台词功底和稳定的表演，成为多部现实主义作品中的定海神针。',
    ],
    workIds: ['peach-33d', 'city-light', 'tropical-rain'],
  },
  {
    id: 'jiang-wan',
    name: '江晚',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actress%20with%20soft%20natural%20lighting%20against%20a%20muted%20rose%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20serene%20expression%2C%20high%20detail&width=500&height=500&seq=actor-jiang-wan-e5&orientation=squarish',
    birthYear: 1991,
    region: '中国大陆',
    height: '170cm',
    roleTag: '主演',
    summary: '气质文艺的女演员，擅长诠释情绪细腻的慢节奏角色。',
    bio: [
      '江晚在多部文艺片中担纲主演，以极具氛围感的表演风格受到关注。',
      '她偏爱与自然光影有关的作品，认为「安静本身就是一种表演」。',
    ],
    workIds: ['peach-1', 'summer-heartbeat', 'tropical-rain', 'rainy-monsoon'],
  },
  {
    id: 'lu-xinghe',
    name: '陆星河',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actor%20with%20soft%20natural%20lighting%20against%20a%20warm%20mint%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20friendly%20expression%2C%20high%20detail&width=500&height=500&seq=actor-lu-xinghe-f6&orientation=squarish',
    birthYear: 1985,
    region: '中国香港',
    height: '180cm',
    roleTag: '主演',
    summary: '戏路宽广的青年演员，都市与公路题材中表现活跃。',
    bio: [
      '陆星河出演过多部都市与公路题材作品，擅长用生活化的细节塑造角色。',
      '他认为「好角色应该像身边的人一样真实可信」。',
    ],
    workIds: ['peach-1', 'midnight-neon', 'seaside-bookstore', 'south-train'],
  },
  {
    id: 'wen-qingyan',
    name: '温清妍',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actress%20with%20soft%20natural%20lighting%20against%20a%20soft%20peach%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20warm%20smile%2C%20high%20detail&width=500&height=500&seq=actor-wen-qingyan-g7&orientation=squarish',
    birthYear: 1990,
    region: '中国台湾',
    height: '166cm',
    roleTag: '主演',
    summary: '治愈系代表演员，作品多以温暖细腻的现实题材为主。',
    bio: [
      '温清妍以温暖亲和的银幕形象深受观众喜爱，常在治愈系作品中担任主角。',
      '她注重角色的真实质感，表演克制而富有温度。',
    ],
    workIds: ['peach-2', 'city-light', 'old-letter', 'seaside-bookstore'],
  },
  {
    id: 'qin-lang',
    name: '秦朗',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20portrait%20of%20a%20young%20Chinese%20actor%20with%20soft%20natural%20lighting%20against%20a%20deep%20terracotta%20simple%20studio%20background%2C%20cinematic%20editorial%20photography%2C%20confident%20expression%2C%20high%20detail&width=500&height=500&seq=actor-qin-lang-h8&orientation=squarish',
    birthYear: 1987,
    region: '中国大陆',
    height: '183cm',
    roleTag: '主演',
    summary: '擅长现实题材与悬疑氛围塑造的实力派男演员。',
    bio: [
      '秦朗在多部现实与悬疑题材作品中担纲主演，以稳定的表演获得认可。',
      '他喜欢挑战不同类型的角色，不断拓宽自己的表演边界。',
    ],
    workIds: ['midnight-neon', 'city-light', 'rose-apartment', 'south-train'],
  },
];